import { A as u, c as f } from "./chunk-aria-live-region-context-BoiIzOeU.js";
import { c as S, a as L } from "./chunk-cart-sections-BB6iP-t5.js";
import { m as C } from "./chunk-modal-context-tNw15YTy.js";
import { c as x } from "./chunk-quickshop-Bd0czKdZ.js";
import { s as P } from "./chunk-context-request-event-Dz3F6XBd.js";
import { i as O } from "./chunk-lit-element-CNHURX5C.js";
import { t as w } from "./chunk-custom-element-ttkHUa8w.js";
import { r as d } from "./chunk-state-DXVUuFZf.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class A {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, s = !1) {
    const i = s || !Object.is(t, this.o);
    this.o = t, i && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [s, { disposer: i }] of this.subscriptions) s(this.o, i);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, s, i) {
    if (!i) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: () => {
      this.subscriptions.delete(t);
    }, consumerHost: s });
    const { disposer: o } = this.subscriptions.get(t);
    t(this.value, o);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let D = class extends Event {
  constructor(t, s) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = s;
  }
};
class _ extends A {
  constructor(t, s, i) {
    var o, r;
    super(s.context !== void 0 ? s.initialValue : i), this.onContextRequest = (a) => {
      if (a.context !== this.context) return;
      const n = a.contextTarget ?? a.composedPath()[0];
      n !== this.host && (a.stopPropagation(), this.addCallback(a.callback, n, a.subscribe));
    }, this.onProviderRequest = (a) => {
      if (a.context !== this.context || (a.contextTarget ?? a.composedPath()[0]) === this.host) return;
      const n = /* @__PURE__ */ new Set();
      for (const [E, { consumerHost: b }] of this.subscriptions) n.has(E) || (n.add(E), b.dispatchEvent(new P(this.context, b, E, !0)));
      a.stopPropagation();
    }, this.host = t, s.context !== void 0 ? this.context = s.context : this.context = s, this.attachListeners(), (r = (o = this.host).addController) == null || r.call(o, this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new D(this.context, this.host));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function p({ context: e }) {
  return (t, s) => {
    const i = /* @__PURE__ */ new WeakMap();
    if (typeof s == "object") return { get() {
      return t.get.call(this);
    }, set(o) {
      return i.get(this).setValue(o), t.set.call(this, o);
    }, init(o) {
      return i.set(this, new _(this, { context: e, initialValue: o })), o;
    } };
    {
      t.constructor.addInitializer((a) => {
        i.set(a, new _(a, { context: e }));
      });
      const o = Object.getOwnPropertyDescriptor(t, s);
      let r;
      if (o === void 0) {
        const a = /* @__PURE__ */ new WeakMap();
        r = { get() {
          return a.get(this);
        }, set(n) {
          i.get(this).setValue(n), a.set(this, n);
        }, configurable: !0, enumerable: !0 };
      } else {
        const a = o.set;
        r = { ...o, set(n) {
          i.get(this).setValue(n), a == null || a.call(this, n);
        } };
      }
      return void Object.defineProperty(t, s, r);
    }
  };
}
var R = Object.defineProperty, k = Object.getOwnPropertyDescriptor, l = (e, t, s, i) => {
  for (var o = i > 1 ? void 0 : i ? k(t, s) : t, r = e.length - 1, a; r >= 0; r--)
    (a = e[r]) && (o = (i ? a(t, s, o) : a(o)) || o);
  return i && o && R(t, s, o), o;
};
const c = {
  OPEN: "modal-dialog::open",
  CLOSE: "modal-dialog::close",
  CLOSE_ALL: "modal-dialog::close-all"
}, m = {
  UPDATED: "cart:updated",
  UPDATED_SECTIONS: "cart:updated-sections"
}, v = {
  OPEN: "quickshop::open",
  CLOSE: "quickshop::close"
}, g = "modals";
let h = class extends O {
  constructor() {
    super(...arguments), this.cart = window.__CART__, this.cartSections = {}, this.modals = [], this.quickShop = null;
  }
  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    this.addEventListener(
      m.UPDATED,
      this._handleCartUpdate.bind(this)
    ), this.addEventListener(
      m.UPDATED_SECTIONS,
      this._handleCartSectionsUpdate.bind(this)
    ), this.addEventListener(
      u.SET,
      this._handleAriaLiveRegionSet.bind(this)
    ), this.addEventListener(
      u.CLEAR,
      this._handleAriaLiveRegionClear.bind(this)
    ), this.addEventListener(
      "click",
      this._handleDialogSchemaClick.bind(this)
    ), Object.values(c).forEach((e) => {
      this.addEventListener(
        e,
        this._handleDialogEvent.bind(this)
      );
    }), Object.values(v).forEach((e) => {
      this.addEventListener(
        e,
        this._handleQuickShopEvent.bind(this)
      );
    }), this._handleRestoreModals();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener(
      m.UPDATED,
      this._handleCartUpdate.bind(this)
    ), this.removeEventListener(
      m.UPDATED_SECTIONS,
      this._handleCartSectionsUpdate.bind(this)
    ), this.removeEventListener(
      u.SET,
      this._handleAriaLiveRegionSet.bind(this)
    ), this.removeEventListener(
      u.CLEAR,
      this._handleAriaLiveRegionClear.bind(this)
    ), this.removeEventListener(
      "click",
      this._handleDialogSchemaClick.bind(this)
    ), Object.values(c).forEach((e) => {
      this.removeEventListener(
        e,
        this._handleDialogEvent.bind(this)
      );
    }), Object.values(v).forEach((e) => {
      this.removeEventListener(
        e,
        this._handleQuickShopEvent.bind(this)
      );
    });
  }
  _handleCartUpdate(e) {
    e.detail && (this.cart = e.detail);
  }
  _handleCartSectionsUpdate(e) {
    e.detail && (this.cartSections = e.detail || {});
  }
  _handleDialogSchemaClick(e) {
    const t = e.composedPath(), s = t.length > 0 ? t[0] : e.target;
    if (s.tagName === "A") {
      const i = s.getAttribute("href");
      if (i && (i.startsWith("modal-dialog://") || i.startsWith("#modal-dialog://"))) {
        e.preventDefault();
        const o = i.replace("modal-dialog://", "").replace("#", "");
        o && this._handleDialogEvent(
          new CustomEvent(c.OPEN, { detail: o })
        );
      }
    }
  }
  _handleDialogEvent(e) {
    let t = [...this.modals];
    switch (e.type) {
      case c.OPEN:
        e.detail && (t = [...t, e.detail]);
        break;
      case c.CLOSE:
        e.detail && (t = t.filter((s) => s !== e.detail)), this.quickShop = null;
        break;
      case c.CLOSE_ALL:
        t = [], this.quickShop = null;
        break;
    }
    t = [...new Set(t)], this.modals = t, this._applyModalsState(), this._updateQueryParams();
  }
  async _applyModalsState() {
    await customElements.whenDefined("modal-dialog");
    const e = this.modals, t = Array.from(
      this.querySelectorAll("modal-dialog")
    );
    for (const s of t)
      e.includes(s.id) ? s.show() : s.hide();
  }
  _handleRestoreModals() {
    const t = new URLSearchParams(window.location.search).get(g);
    t && (this.modals = t.split(",").map((s) => s.trim()).filter(Boolean), this._applyModalsState());
  }
  _updateQueryParams() {
    const e = new URLSearchParams(window.location.search), t = this.modals, s = this.modals.join(",");
    t.length > 0 ? e.set(g, s) : e.delete(g);
    const i = `${window.location.pathname}?${e.toString()}`;
    window.history.replaceState({}, "", i);
  }
  _handleAriaLiveRegionSet(e) {
    e.detail && (this.ariaLiveRegion = e.detail);
  }
  _handleAriaLiveRegionClear() {
    this.ariaLiveRegion = {
      message: ""
    };
  }
  _handleQuickShopEvent(e) {
    const t = e.type, s = e.detail;
    t === v.OPEN ? this.quickShop = s : this.quickShop = null;
  }
};
l([
  p({ context: S }),
  d()
], h.prototype, "cart", 2);
l([
  p({ context: L }),
  d()
], h.prototype, "cartSections", 2);
l([
  p({ context: C }),
  d()
], h.prototype, "modals", 2);
l([
  p({ context: f }),
  d()
], h.prototype, "ariaLiveRegion", 2);
l([
  p({ context: x }),
  d()
], h.prototype, "quickShop", 2);
h = l([
  w("app-provider")
], h);
export {
  h as AppProvider
};
